import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import { LiveopsRewardType } from '@/modules/liveops/item/types';
import router, { ROUTE_NAME_LIVEOPS } from './router';

export default registerRouteForModule(router);

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Liveops',
        name: 'LiveOps',
        icon: 'fas fa-satellite-dish',
        roles: [Role.ADMIN]
    },
    {
        parent: 'Multiplayer.Liveops',
        key: 'PointEvent',
        name: 'Point Event',
        icon: 'fas fa-star',
        route: { name: ROUTE_NAME_LIVEOPS.ITEM.INDEX(LiveopsRewardType.Milestone) }
    },
    {
        parent: 'Multiplayer.Liveops',
        key: 'LuxuryTable',
        name: 'Luxury Table',
        icon: 'fas fa-crown',
        route: { name: ROUTE_NAME_LIVEOPS.ITEM.INDEX(LiveopsRewardType.Leaderboard) }
    }
]);
